import { trpc } from "#/lib/trpc/client"
import { usePreVisitFormTracking } from "#/services/memberActionTracking/BookingTrackingProvider"
import { HealthieAnswer } from "@internal/telemedicine"
import { useMutation, type UseMutationResult } from "@tanstack/react-query"
import { v4 as uuid } from "uuid"

type SubmitIntakeFormVariables = { appointmentId: string; formId: string; answers: HealthieAnswer[] }
type SubmitIntakeFormData = Awaited<ReturnType<typeof trpc.telemedicine.submitForm.mutate>>

export function useSubmitIntakeForm(): UseMutationResult<SubmitIntakeFormData, Error, SubmitIntakeFormVariables> {
  const trackSubmission = usePreVisitFormTracking()
  return useMutation({
    mutationFn: async ({ appointmentId, formId, answers }: SubmitIntakeFormVariables) => {
      // A request-scoped ID pairs outcomes with attempts and keeps rapid retries distinct for action deduplication.
      const trackSuccess = trackSubmission(appointmentId, uuid())
      const response = await trpc.telemedicine.submitForm.mutate({ appointmentId, formId, answers })
      trackSuccess()
      return response
    }
  })
}
